"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpperMemberList = void 0;
const react_1 = __importStar(require("react"));
const server_1 = require("../../../../../server");
const common_1 = require("../../../../../common");
const Colors_1 = require("../../../../../Colors");
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
const popup_1 = require("../../../../base/popup");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const UpperMemberListStyled = styled_components_1.default.div `
	${props => (props.$isTablet ? tabletStyles : desktopStyles)}
`;
const tabletStyles = (0, styled_components_1.css) `
	display: flex;
	flex-direction: column;
	gap: 0px;
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	flex-shrink: 0;
	position: relative;
	overflow: hidden;

	.popup-list-009 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		overflow: auto;

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0px 0px 0px;
			padding: 12px 10px 12px 10px;
			display: flex;
			flex-direction: row;
			gap: 10px;
			align-items: center;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;

			color: var(--color-black, #101010);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 14px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 12px 10px 12px 10px;
			display: flex;
			flex-direction: row;
			gap: 10px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 14px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;

			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}
	}
	&.upper-member-list {
		gap: 24px;
		.btn-container {
			width: 100%;
			justify-content: center;
		}
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: hidden;
	justify-content: center;
	align-items: center;

	.popup-list-009 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		overflow: auto;
		flex: 1;

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0px 0px 0px;
			padding: 10px 16px 10px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 12px 16px 12px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
		}
	}
`;
exports.UpperMemberList = react_1.default.memo(({ test_id, subject_item, precedence, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    const [testData, setTestData] = (0, react_1.useState)([]);
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    const { headTitleList, tableReadDataKeys } = react_1.default.useMemo(() => {
        // 기본적인 항목들
        const headTitleList = [
            { title: 'rankings', space: 1, sort: false },
            { title: 'nameId', space: 2, sort: false },
            { title: 'grades', space: 1, sort: false },
        ];
        const tableReadDataKeys = [
            { title: 'number', space: 1 },
            { title: 'member_name', space: 2 },
            { title: 'score', space: 1 },
        ];
        // useMemo에서 반환
        return { headTitleList, tableReadDataKeys };
    }, []);
    const { data, refetch } = (0, server_1.useSubmitStatus)({
        precedence,
        id: test_id,
        subject_item,
    });
    (0, react_1.useEffect)(() => {
        refetch();
    }, [precedence, subject_item, test_id]);
    (0, react_1.useEffect)(() => {
        if (data) {
            setTestData(data.items);
            setTotalCount(data.total_count);
            return;
        }
        setTestData([]);
        setTotalCount(0);
    }, [data]);
    const renderEmpty = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement("div", { className: "flex center body3 sel_eval_item", style: { color: Colors_1.Colors.light_grey, width: '100%', height: '100%' } }, t('assignment.noSubmitPersonGuid')));
    }, []);
    const renderItem = (item, styles) => {
        return tableReadDataKeys.map(headItem => (react_1.default.createElement("div", { key: headItem.title, className: "body-item", style: { flex: headItem.space, ...styles?.bodyItem, overflow: 'hidden' } },
            react_1.default.createElement("p", { className: "overText" }, item[headItem.title] === -1 ? '미제출' : item[headItem.title]))));
    };
    const onCancel = () => APP.eventManager.publish(popup_1.TOGGLE_POPUP);
    return (react_1.default.createElement(UpperMemberListStyled, { "$isTablet": isTablet, className: "upper-member-list" },
        react_1.default.createElement(common_1.Table, { className: "popup-list-009", showIndex: false, isInfinite: true, page: 0, data: testData, renderEmpty: testData && testData.length < 0 && renderEmpty, totalCount: 0, headTitleList: headTitleList, renderItem: renderItem }),
        react_1.default.createElement("div", { className: "btn-container" },
            react_1.default.createElement(common_1.Button, { className: "btn_default sm", text: t('common.okay'), onClick: onCancel }))));
});
